const CAD_REGEX = /^[a-zA-Z][0-9][a-zA-Z]\s*[0-9][a-zA-Z][0-9]$/;

export const currencyForZIP = (zip: string): 'USD' | 'CAD' => {
  if (CAD_REGEX.test(zip.trim())) return 'CAD';
  return 'USD';
};
